module.exports = __webpack_public_path__ + "images/category_lp/smartwatch/store_images/3_8ff57756346730e943a34f4090a88b6c.png";